import { Flex } from "@chakra-ui/layout";
import { Box, Collapse, Text } from "@chakra-ui/react";
import { ProcuracaoDetalheUnidade } from "core/features/assembleia/typings/procuracao";
import colors from "core/resources/theme/colors";
import { formatBlocoQuadra } from "infra/helpers/formatBlocoQuadra";
import { useState } from "react";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";

export const CollapsePesos = ({
  unidades,
}: {
  unidades: ProcuracaoDetalheUnidade[];
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const totalPeso = unidades.reduce((acc, next) => {
    acc = acc + next.peso;
    return acc;
  }, 0);

  return (
    <Box
      cursor="pointer"
      onClick={() =>
        setCollapsed((currentCollapsed) =>
          unidades.length ? !currentCollapsed : currentCollapsed
        )
      }
      w="100%"
      px="24px"
    >
      <Flex w="100%" alignItems="center" justifyContent="space-between">
        <Text fontSize={18} mb={3}>
          Total de pesos
        </Text>

        {collapsed ? (
          <BiChevronDown fontSize={40} />
        ) : (
          <BiChevronUp fontSize={40} />
        )}
      </Flex>
      <Box>
        <Text fontSize={36} fontWeight="bold">
          {totalPeso || 0}
        </Text>
      </Box>

      <Collapse in={!collapsed}>
        <Box mt={6}>
          {unidades.map((unidade, index) => (
            <CardPeso
              key={index}
              unidadeNome={formatBlocoQuadra(
                unidade.numero,
                unidade.blocoQuadra
              )}
              peso={unidade.peso}
            />
          ))}
        </Box>
      </Collapse>
    </Box>
  );
};

const CardPeso = ({
  unidadeNome,
  peso,
}: {
  unidadeNome: string;
  peso: number;
}) => (
  <Flex
    justifyContent="space-between"
    px={8}
    py={4}
    rounded={16}
    mb={2}
    borderWidth={2}
    borderColor={colors.black700}
  >
    <Flex flexDir="column">
      <Text color={colors.black700} fontWeight="medium" fontSize={16}>
        UNIDADE:
      </Text>
      <Text fontSize={18}>{unidadeNome}</Text>
    </Flex>

    <Flex flexDir="column">
      <Text color={colors.black700} fontWeight="medium" fontSize={16}>
        PESO:
      </Text>
      <Text fontSize={18} fontWeight="bold">
        {peso}
      </Text>
    </Flex>
  </Flex>
);
